import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/shared/services/setting.service';
import { Observable } from 'rxjs';
import { IAddress } from 'src/app/shared/services/address.service';
import { ICustomerTransactionEmail } from '../components/receipt/receipt.component';
import { finalize, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { PageService } from 'src/app/services/page.service';
import { ToastController } from '@ionic/angular';
//import * as moment from 'moment';
import moment from 'moment';
import { IDescription, IDescriptionExtended, IMeasurements, IStore, IStoreMenuItem, ITranslatableText } from './store.service';
import { OrderType } from '../pages/list-page/list-page.component';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { int } from '@zxing/library/esm/customTypings';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';

export interface IOrderShipping {
    orderShippingItems: IOrderItem[];
    note: string;
  }

export interface IPlaceOrderBase {
    merchantId: string;
    storeId: string;
    order: IOrder;
    customerFirstName: string;
    customerLastName: string;
    customerName: string;
    customerEmail: string;
    phone: string;
    giftCard?: string;
    eCouponCode?: string;
    deliveryNote: string;
    deliveryAddress: IAddress,
    language: string;
    orderTip: number;
    timeZone: string;
    orderDate: string;
    orderTime: string;
    estimatedTime?: string;
    deliveryPrice: number;
    storeDistance?: number;
    sendNotification?:boolean;
    convenienceFee:number;
    ipAddress:string;
    origin: int;
    threeDSTransactionId?: string;
    giftCardConsNumber?: string;
    isMeetAtDoor?: boolean; // for uber direct
    includeUtensils?: boolean;
    seatInfo?: ISeatInfo;
    cloverPaymentToken?: string;
    cloverThreeds?: IFinalizeThreeds;
    cloverThreedsNoChallenge?: boolean;    
}

export interface IPlaceOrderShippingBase {
    merchantId: string;
    storeId: string;
    orderShipping: IOrderShipping;
    customerFirstName: string;
    customerLastName: string;
    customerName: string;
    customerEmail: string;
    phone: string;
    giftCard?: string;
    eCouponCode?: string;
    note: string;
    shippingAddress: IAddress,
    language: string;
    orderTip: number;
    timeZone: string;
    orderDate: string;
    orderTime: string;
    origin: int;
    estimatedTime?: string;
    shippingPrice: number;
    storeDistance?: number;
    sendNotification?:boolean;
    convenienceFee:number;
    cloverPaymentToken?: string;
}

export interface IDeliveryAddress {
    postalCode: string;
    city: string;
    province: string;
    streetDirection: string;
    street: string;
    streetType: string;
    streetNumber: string;
    suiteNumber?: string;
    country?: string;
}

export interface IOrder {
    store: IStore;
    orderItems: IOrderItem[];
    note: string;
    orderDate?: string;
    orderTime?: string;
    _deliveryType: OrderType;
    _seatInfo?: ISeatInfo;
}

export interface IOrderItem {
    itemId: string;
    itemName: ITranslatableText;
    itemNumber: string;
    quantity: number;
    price: number;
    options: IOrderItemOption[];
    allergies: string;
    note: string;
    taxEligible: boolean;
    _hidePrice: boolean;
    _chainItemId: string;
    itemDetailCombination?: IItemDetailCombination;
    itemAvailableHour?: IAvailableHour[];
    isDelivery?:boolean;
    orderType: OrderType;
    isAlcohol?: boolean;
    isFree?: boolean;
    _originalPrice?: number;
    _isTwoForOne?: boolean;
    item?: any;
    totalPrice?: number;
    name?: string;

    isFoodItem: boolean;
    _relatedStoreId?: string;

    // recently added:
    description?: ITranslatableText;
    descriptionExtended?: IDescriptionExtended;
    itemImageShortName?: string
    _itemImage?: any;
    _parentItem?: IStoreMenuItem;
}

export interface IAvailableHour {
    day: number,
    startHours?: string, 
    endHours?: string
}

export interface IItemDetailCombination {
    code: string;
    colorId: string;
    id: string;
    isDeleted: false;
    price: number;
    sizeId: string;
    measurementsId: string;
    size?: ITranslatableText,
    color?: ITranslatableText,
    measurements?: IMeasurements,
    quantity?: number
}
export interface IOrderItemOption {
    optionId: string;
    itemId: string;
    itemNumber: string;
    quantity: number;
    price: number;
    name: ITranslatableText;
    itemOptionCategoryId: string;
    itemDetailCombination?: IItemDetailCombination;
    _parentOptionCategoryId?: string;
}

export interface ISeatInfo{
    section: string;
    row: string;
    seatNumber: string;
}

export enum OrderStatus{
    Initialized = 0,
    Accepted = 1,
    Prepare = 2,
    ReadyForPickup = 3,
    ReadyForShipping = 3,
    OutForDelivery = 4,
    OutForShipping = 4,
    Completed = 5    
}

export interface IOrderPlacedNotification {
    id: string;
    storeId: string;
    terminalId: number;
    storeTimeZone: string;
    number: number;
    customerEmail: string;
    customerName: string;
    customerPhone: string;
    isDelivery: boolean;
    deliveryAddress?: IDeliveryAddress;
    language: string;
    orderDate: string;
    isDelayedOrder: boolean;
    orderedForDate: string;
    tip: number;
    deliveryFee: number;
    subtotal: number;
    total: number;
    note?: string;
    isDoorDashDrive: boolean;
    isUberDirect: boolean;
    items: {
        id?: string;
        name: string;
        itemNumber: string;
        quantity: number;
        totalPrice: number;
        price: number,
        allergies?: string;
        note?: string;
        isAlcohol?: boolean;
        itemDetailCombination:{
            id: string,
            sizeId: string,
            color: string,
            size: string,
            colorId: string,
            code: string,
            price: string,
            isDeleted: false
        }
        options: {
            id?:string;
            itemId?: string;
            quantity: number;
            price: number;
            name: any;

            optionId?: string,
            itemNumber?: string,
            itemOptionCategoryId? :string
        }[];
 
    }[];
    status: OrderStatus,
    statusActivityLog: {
        activity: OrderStatus,
        logTime: string;
    }[];
}


export interface IOrderShippingPlacedNotification {
    id: string;
    storeId: string;
    terminalId: number;
    storeTimeZone: string;
    number: number;
    customerEmail: string;
    customerName: string;
    customerPhone: string;
    shippingAddress?: IDeliveryAddress;
    language: string;
    orderDate: string;
    isDelayedOrder: boolean;
    orderedForDate: string;
    tip: number;
    shippingFee: number;
    subtotal: number;
    total: number;
    note?: string;
    items: {
        id?: string;
        name: string;
        quantity: number;
        totalPrice: number;
        price: number,
        allergies?: string;
        note?: string;
    itemDetailCombination:{
        id: string,
        sizeId: string,
        color: ITranslatableText,
        size: ITranslatableText,
        colorId: string,
        code: string,
        price: string,
        isDeleted: false
    }
        options: {
            id?:string;
            quantity: number;
            price: number;
            name: string;
        }[];
 
    }[];
    status: OrderStatus,
    statusActivityLog: {
        activity: OrderStatus,
        logTime: string;
    }[];
    trackers : {
        carrier: string,
        trackigNumber: string,
        trackingUrl: String
    }[];
}

export interface FindAllPlacedOrderModel {
    merchantId: string;
}

export interface FindAllPlacedOrderShippingModel {
    merchantId: string;
}

export interface PlacedOrderDisplayModel {
    orderId: string;
    orderNumber: number;
    date: string;
    isDelivery: boolean;
    isShipping: boolean;
    orderStatus: OrderStatus;
    storeId?: string;
    storeName?: string;

    storeAllowSales?: boolean;
}

export interface IMemberPlaceOrder extends IPlaceOrderBase {
    cvn: number;
    savedCardId: string;

    // for promotions:
    promotionCode?: string;
    orderType?: string;
    accountId: string | number;
    visitorId?: string;
}

export interface IPlaceOrder extends IPlaceOrderBase {
    orderId?: string;
    creditCard?: ICreditCard;
    billingAddress: IAddress;

    // for promotions:
    promotionCode?: string;
    orderType?: string;
    accountId: string | number;
    isMember?: boolean; // this one is only for 3ds. don't set a value for the regular "placeOrder"
    visitorId?: string;
}

export interface IMemberPlaceOrderShipping extends IPlaceOrderShippingBase {
    cvn: number;
    savedCardId: string;

    // for promotions:
    promotionCode?: string;
    orderType?: string;
    accountId?: string | number;
    visitorId?: string;
}

export interface IPlaceOrderShipping extends IPlaceOrderShippingBase {
    creditCard?: ICreditCard;
    billingAddress: IAddress;

    // for promotions:
    promotionCode?: string;
    orderType?: string;
    accountId?: string | number;
    visitorId?: string;
}

export interface ICreditCard {
    number: number;
    expirationDate: string;
    cardHolderName: string;
    type?: string;
    cvnNumber: number;
}

export interface IGiftCardBalancePreAuthorization {
    storeId: string;
    language: string;
    amount: number;
    hardwareInfo: string;
    cvc: number;
}
export interface ICouponInformation {
    storeId: string;
    language: string;
    amount: number;
    hardwareInfo: string;
    totalAmount: number;
    items: ICouponItem[];
}

export interface ICouponItem {
    price: number,
    qty: number,
    unitPrice: number,
    upc: string
}

export interface IGiftCardBalancePreAuthorizationResponse {
    amount: number;
}
export interface ICouponDiscount {
    amount: number;
}

export interface IPromotionInformation {
    merchantId: string;
    storeId: string;
    language: string;
    promotionCode: string
    subTotalAmount: number;
    totalAmount: number;
    orderType: string;
    accountId: string | number;
    isMember: boolean;
    orderContent?: IOrder;
    visitorId?: string;
}

export interface IPromotionDiscount {
    error: boolean;
    discountAmount: number;
    applyAfterTax: boolean;
    applyOnItem: boolean;
    discountedItemId: string;
    applyDeliveryFee: boolean;
}

export interface IOrderDriver{
    driverStatus:string;
    driverEstimatedDeliveryTime : string;
    driverEstimatedPickupTime : string;
    isDoorDashDriveUser: boolean;
    doorDashDriveOrderId: string;
    timeNow:string;
}

export interface ICloverCreateChargeResponseModel {
    id:string;
    amount: int;
    payment_method_details: string;
    amount_refunded: int;
    currency:string;
    created: bigint;
    captured: boolean;
    ref_num: string; 
    auth_code: string;
    outcome: IOutcome;
    paid: boolean;
    status: string;
    source: ISource;
    threeds: IThreeds;
}

export interface IOutcome
{
    network_status: string;
    type: string;
}

export interface ISource
{
    id:string;
    address_line1_check:string;
    address_zip:string; 
    address_zip_check:string; 
    brand:string; 
    exp_month:string;
    exp_year:string; 
    first6:string; 
    last4:string;
    name:string;
}

export interface IThreeds
{
   validation_result: string; 
   liability_protection_status: string;
   source; string; 
   data: IThreedsData;
}

export interface IFinalizeThreeds
{
    source: string;
    flow_status: string;
}

export interface IThreedsData
{
    method_url:string; 
    method_notification_url:string; 
    threeds_server_transaction_id:string;
    threeds_protocol_version:string;
    acs_url: string;
    acs_notification_url: string;
    acs_transaction_id: string;
}

export interface  ICloverCreate3DSChargeRequestModel
{
        order: IPlaceOrder;
        threeds?: IThreedsRequest;
}

export interface IThreedsRequest 
{
    source: string;
    browser_info: ICloverBrowserInfo;
}

export interface ICloverBrowserInfo
{
        browser_ip: string;
        browser_accept_header: string;
        browser_color_depth: string; 
        browser_http_origin: string; 
        browser_java_enabled: boolean; 
        browser_javascript_enabled: boolean;
        browser_language: string; 
        browser_screen_height: string; 
        browser_screen_width: string; 
        browser_tz: string; 
        browser_user_agent: string; 
}

@Injectable({
    providedIn: 'root'
})
export class OrderService {
    reOrder: boolean;

    orders: PlacedOrderDisplayModel[] = [];
    ordersShipping: PlacedOrderDisplayModel[] = [];
    loadedFindAllPlacedOrders: boolean = false;
    changedFindAllPlacedOrders: boolean = false;
    loadedFindAllPlacedOrdersShipping: boolean = false;
    changedFindAllPlacedOrdersShipping: boolean = false;


    constructor(private http: HttpClient,
        private setting: SettingService,
        private auth: AuthService,
        private page: PageService,
        //private translateService: TranslateService,
        private toastCtrl: ToastController,
        private analytics: AnalyticsService,
        private translationService: TranslationService,
        private apiController: ApiControllerService) { }

    findMemberAllPlacedOrder() {
        return new Observable<PlacedOrderDisplayModel[]>(o => {
            let headers = this.auth.getAuthHeadersBaseObject();

            const model : FindAllPlacedOrderModel = {
                merchantId: this.setting.getMerchantId()
            };

            /*
            if(this.loadedFindAllPlacedOrders && !this.changedFindAllPlacedOrders) {
                o.next(this.orders);
                o.complete();
            } else {
            */


                /* this.http.post(this.setting.apiUrl('Order/FindMemberAllPlacedOrder'), model,
                {
                    headers: headers
                })
                    .pipe(finalize(() => {
                        o.complete();
                    }),
                    tap((data)=>{
                    })
                    
                    )
                    .subscribe((data: PlacedOrderDisplayModel[]) => {
                        this.orders = data;
                        o.next(data);
                    }, (error) => {
                        o.error(error);
                    }); */

                this.apiController.post(this.setting.apiUrl('Order/FindMemberAllPlacedOrder'), model,
                {
                    headers: headers
                })
                    .pipe(finalize(() => {
                        o.complete();
                    }),
                    tap((data)=>{
                    })
                    
                    )
                    .subscribe((data: PlacedOrderDisplayModel[]) => {
                        this.orders = data;
                        this.loadedFindAllPlacedOrders = true;
                        this.changedFindAllPlacedOrders = false;
                        o.next(data);
                    }, (error) => {
                        o.error(error);
                    });
            //}
            
        });
    }

    findMemberAllPlacedOrderShipping() {
        return new Observable<PlacedOrderDisplayModel[]>(o => {
            let headers = this.auth.getAuthHeadersBaseObject();

            const model : FindAllPlacedOrderShippingModel = {
                merchantId: this.setting.getMerchantId()
            };

            /* this.http.post(this.setting.apiUrl('OrderShipping/FindMemberAllPlacedOrderShipping'), model,
            {
                headers: headers
            })
                .pipe(finalize(() => {
                    o.complete();
                }),
                tap((data)=>{
                })
                
                )
                .subscribe((data: PlacedOrderDisplayModel[]) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                }); */


            /*
            if(this.loadedFindAllPlacedOrdersShipping && !this.changedFindAllPlacedOrdersShipping) {
                o.next(this.ordersShipping);
                o.complete();
            } else {
            */
                this.apiController.post(this.setting.apiUrl('OrderShipping/FindMemberAllPlacedOrderShipping'), model,
                {
                    headers: headers
                })
                    .pipe(finalize(() => {
                        o.complete();
                    }),
                    tap((data)=>{
                    })
                    
                    )
                    .subscribe((data: PlacedOrderDisplayModel[]) => {
                        this.ordersShipping = data;
                        this.loadedFindAllPlacedOrdersShipping = true;
                        this.changedFindAllPlacedOrdersShipping = false;
                        o.next(data);
                    }, (error) => {
                        o.error(error);
                    });
            //}

            
        });
    }

    giftCardBalancePreAuthorization(model: IGiftCardBalancePreAuthorization) {
        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Order/GiftCardBalancePreAuthorization'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IGiftCardBalancePreAuthorizationResponse) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                }); */

            this.apiController.post(this.setting.apiUrl('Order/GiftCardBalancePreAuthorization'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IGiftCardBalancePreAuthorizationResponse) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                });
        });
    }

    validateECouponsDiscount(model: ICouponInformation)
    {
        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Order/ECouponsDiscountValidation'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICouponDiscount) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                }); */

            this.apiController.post(this.setting.apiUrl('Order/ECouponsDiscountValidation'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICouponDiscount) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                });
        });
    }

    
    validatePromotionDiscount(model: IPromotionInformation)
    {
        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Order/PromotionDiscountValidation'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IPromotionDiscount) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                }); */

            this.apiController.post(this.setting.apiUrl('Order/PromotionDiscountValidation'), model)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IPromotionDiscount) => {
                    o.next(data);
                }, (error) => {
                    o.error(error);
                });
        });
    }

    place3DSOrderValidation(order: IPlaceOrder): Observable<ICustomerTransactionEmail> {
        //When it is a 100% gift card transaction, must set a date for the expiration and the number = 0 otherwise the server freakout with his model
        if (order.creditCard && order.creditCard.expirationDate == "Invalid date") {
            order.creditCard.expirationDate = moment().format("YYYY-MM-DD");
            order.creditCard.number = 0;
        }

         //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
        //the server will reject the cvc number not being able to convert it to int
        if (order.creditCard && !isNaN(order.creditCard.cvnNumber)) {
            order.creditCard.cvnNumber = Number(order.creditCard.cvnNumber);
        }

        return Observable.create(o => {
            //this function is used for both guest and member, so we add the header only when required
            
            var headers;
            if (this.auth.isAuthenticated) {          
                headers = this.auth.getAuthHeadersBaseObject();
                this.page.appendAuthorizationHeader(headers); 
            }

            /* this.http.post(this.setting.apiUrl('Order/ThreeDSPlaceOrderPreAuth'), order, { headers: headers })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);
                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                                   
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                }); */

            this.apiController.post(this.setting.apiUrl('Order/ThreeDSPlaceOrderPreAuth'), order, { headers: headers })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);
                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                                   
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                });
        });
    }

    place3DSOrderConfirmation(order: IPlaceOrder, isClover: boolean = false, cloverInfo: IFinalizeThreeds = null): Observable<ICustomerTransactionEmail> {
        //When it is a 100% gift card transaction, must set a date for the expiration and the number = 0 otherwise the server freakout with his model
        debugger;
        if (cloverInfo != null) {
            order.cloverThreeds = cloverInfo;
        } else if (isClover) {
                //if no threeds and it is still clover, it means it was a non challenge 3ds transaction
                order.cloverThreedsNoChallenge = true;
        }
        
        if (order.creditCard && order.creditCard.expirationDate == "Invalid date" && !isClover) {
            order.creditCard.expirationDate = moment().format("YYYY-MM-DD");
            order.creditCard.number = 0;
        }

         //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
        //the server will reject the cvc number not being able to convert it to int
        if (order.creditCard && !isNaN(order.creditCard.cvnNumber) && !isClover) {
            order.creditCard.cvnNumber = Number(order.creditCard.cvnNumber);
        }

        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Order/ThreeDSPlaceOrderConfirmAuth'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    // if it reaches that point, this means that the item has been processed
                    // might need to keep track of this one as i may have to move it around. I believe this confirms purchases
                    this.analytics.conversionUpdate("purchaseComplete");
                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                                   
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                }); */

            this.apiController.post(this.setting.apiUrl('Order/ThreeDSPlaceOrderConfirmAuth'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    // if it reaches that point, this means that the item has been processed
                    // might need to keep track of this one as i may have to move it around. I believe this confirms purchases
                    this.analytics.conversionUpdate("purchaseComplete");
                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                                   
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                });
        });
    }

    placeOrder(order: IPlaceOrder): Observable<ICustomerTransactionEmail> {
        
        //When it is a 100% gift card transaction, must set a date for the expiration and the number = 0 otherwise the server freakout with his model
        if (order.creditCard && order.creditCard.expirationDate == "Invalid date") {
            order.creditCard.expirationDate = moment().format("YYYY-MM-DD");
            order.creditCard.number = 0;
        }

         //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
        //the server will reject the cvc number not being able to convert it to int
        if (order.creditCard && !isNaN(order.creditCard.cvnNumber)) {
            order.creditCard.cvnNumber = Number(order.creditCard.cvnNumber);
        }

        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Order/PlaceOrder'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    console.log(data);

                    // if it reaches that point, this means that the item has been processed
                    this.analytics.conversionUpdate("purchaseComplete");

                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                    if(error)
                   {
                       //rajouter if includes doordash
                    //    if(error.errorMessage.includes('DoorDashDelivery') || error.errorMessage.includes('DoorDashDrive')){
                        
                    //         message = this.translateService.instant("Checkout.DoorDashDriveNotAvailable");
                    //    }
                        // if(error.error.includes('One of the item is not Available'))
                        // {
                        //     message=this.translateService.instant("Checkout.NotAvailable");
                        // }
                        // if(error.error.includes('Out of stock'))
                        // {
                        //     message=this.translateService.instant("Checkout.OutOfStock");
                        // }
                        // if(error.error.includes('Transaction above Limit'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLimit")} $${this.setting.configuration.maxDeliveryOrderAmount.toFixed(2)}`
                        // }
                        // if(error.error.includes('Amount is too low'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLow")} $${this.setting.configuration.minDeliveryOrderAmount.toFixed(2)}`
                        // }
                    }
                 
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                }); */

            this.apiController.post(this.setting.apiUrl('Order/PlaceOrder'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    console.log(data);

                    // if it reaches that point, this means that the item has been processed
                    this.analytics.conversionUpdate("purchaseComplete");

                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                    if(error)
                   {
                       //rajouter if includes doordash
                    //    if(error.errorMessage.includes('DoorDashDelivery') || error.errorMessage.includes('DoorDashDrive')){
                        
                    //         message = this.translateService.instant("Checkout.DoorDashDriveNotAvailable");
                    //    }
                        // if(error.error.includes('One of the item is not Available'))
                        // {
                        //     message=this.translateService.instant("Checkout.NotAvailable");
                        // }
                        // if(error.error.includes('Out of stock'))
                        // {
                        //     message=this.translateService.instant("Checkout.OutOfStock");
                        // }
                        // if(error.error.includes('Transaction above Limit'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLimit")} $${this.setting.configuration.maxDeliveryOrderAmount.toFixed(2)}`
                        // }
                        // if(error.error.includes('Amount is too low'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLow")} $${this.setting.configuration.minDeliveryOrderAmount.toFixed(2)}`
                        // }
                    }
                 
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                });
        });
    }

    placeOrderShipping(order: IPlaceOrderShipping): Observable<ICustomerTransactionEmail> {
        
        //When it is a 100% gift card transaction, must set a date for the expiration and the number = 0 otherwise the server freakout with his model
        if (order.creditCard && order.creditCard.expirationDate == "Invalid date") {
            order.creditCard.expirationDate = moment().format("YYYY-MM-DD");
            order.creditCard.number = 0;
        }

         //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
        //the server will reject the cvc number not being able to convert it to int
        if (order.creditCard && !isNaN(order.creditCard.cvnNumber)) {
            order.creditCard.cvnNumber = Number(order.creditCard.cvnNumber);
        }

        return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('OrderShipping/PlaceOrderShipping'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    console.log(data);

                    // if it reaches that point, this means that the item has been processed
                    this.analytics.conversionUpdate("purchaseComplete");

                }, async error => {
                    let message = this.translationService.translate("Checkout.InvalidOrder")      
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                }); */

            this.apiController.post(this.setting.apiUrl('OrderShipping/PlaceOrderShipping'), order)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    console.log(data);

                    // if it reaches that point, this means that the item has been processed
                    this.analytics.conversionUpdate("purchaseComplete");

                }, async error => {
                    let message = this.translationService.translate("Checkout.InvalidOrder")      
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                });
        });
    }

    memberPlaceOrder(order: IMemberPlaceOrder): Observable<ICustomerTransactionEmail> {
        //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
      //the server will reject the cvc number not being able to convert it to int   
      if (!isNaN(order.cvn)) {
          order.cvn = Number(order.cvn);
      }

      return Observable.create(o => {
          let headers = this.auth.getAuthHeadersBaseObject();
          this.page.appendAuthorizationHeader(headers);
   
          /* this.http.post(this.setting.apiUrl('Order/MemberPlaceOrder'), */
          this.apiController.post(this.setting.apiUrl('Order/MemberPlaceOrder'),
              order,
              { headers: headers }
          )
              .pipe(finalize(() => {
                  o.complete();
              }))
              .subscribe((data: ICustomerTransactionEmail) => {
                    o.next(data);

                    console.log(data)

                    // if it reaches that point, this means that the item has been processed
                    this.analytics.conversionUpdate("purchaseComplete");

              }, async error => {
                
                  let message = this.translationService.translate("Checkout.InvalidOrder")
                  if(error)
             {
              //     if(error.errorMessage.includes('DoorDashDelivery') || error.errorMessage.includes('DoorDashDrive')){
                      
              //         message = this.translateService.instant("Checkout.DoorDashDriveNotAvailable");
              //    }
                      // if(error.error.includes('DoorDashDelivery') || error.errorMessage.includes('DoorDashDrive')){
                      //     message = this.translateService.instant("Checkout.DoorDashDriveNotAvailable");
                      // }
                      // if(error.error.includes('One of the item is not Available'))
                      // {
                      //     message=this.translateService.instant("Checkout.NotAvailable");
                      // }
                      // if(error.error.includes('Out of stock'))
                      // {
                      //     message=this.translateService.instant("Checkout.OutOfStock");
                      // }
                      // if(error.error.includes('Transaction above Limit'))
                      // {
                      //     message=`${this.translateService.instant("Checkout.TransactionLimit")} $${this.setting.configuration.maxDeliveryOrderAmount.toFixed(2)}`
                      // }
                      // if(error.error.includes('Amount is too low'))
                      // {
                      //     message=`${this.translateService.instant("Checkout.TransactionLow")} $${this.setting.configuration.minDeliveryOrderAmount.toFixed(2)}`
                      // }
                  }

                  const toast = await this.toastCtrl.create({
                      message: message,
                      position: 'bottom',
                      color: 'danger',
                      cssClass: 'order-toast',
                      buttons: [
                        {
                          side: 'start',
                          icon: 'alert-circle-outline',
                          //cssClass: 'order-error-icon',
                          text: '',
                          handler: () => {
            
                          }
                        }, {
                          text: this.translationService.translate("General.Close"),
                          role: 'cancel',
                          handler: () => {
            
                          }
                        }
                      ]
                    });
                    await toast.present();                   
              });
      });
  }

    memberPlaceOrderShipping(order: IMemberPlaceOrderShipping): Observable<ICustomerTransactionEmail> {
        //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
      //the server will reject the cvc number not being able to convert it to int
      //debugger;        
      if (!isNaN(order.cvn)) {
          order.cvn = Number(order.cvn);
      }

      return Observable.create(o => {
          let headers = this.auth.getAuthHeadersBaseObject();
          this.page.appendAuthorizationHeader(headers);
   
          // this.http.post(this.setting.apiUrl('OrderShipping/MemberPlaceOrderShipping'),
          this.apiController.post(this.setting.apiUrl('OrderShipping/MemberPlaceOrderShipping'),
              order,
              { headers: headers }
          )
              .pipe(finalize(() => {
                  o.complete();
              }))
              .subscribe((data: ICustomerTransactionEmail) => {
                  o.next(data);
                  // if it reaches that point, this means that the item has been processed

                  console.log(data)

                  this.analytics.conversionUpdate("purchaseComplete");
              }, async error => {
                let message = this.translationService.translate("Checkout.InvalidOrder")
                const toast = await this.toastCtrl.create({
                    message: message,
                    position: 'bottom',
                    color: 'danger',
                    cssClass: 'order-toast',
                    buttons: [
                    {
                        side: 'start',
                        icon: 'alert-circle-outline',
                        //cssClass: 'order-error-icon',
                        text: '',
                        handler: () => {
        
                        }
                    }, {
                        text: this.translationService.translate("General.Close"),
                        role: 'cancel',
                        handler: () => {
        
                        }
                    }
                    ]
                });
                await toast.present();                   
              });
      } );
    }

    findPlacedOrderById(orderId: string) {

        return new Observable<IOrderPlacedNotification>((o) => {
            //this.http.post(this.setting.apiUrl('Order/FindPlacedOrderById'),
            this.apiController.post(this.setting.apiUrl('Order/FindPlacedOrderById'),
                {
                    orderId: orderId
                })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IOrderPlacedNotification) => {
                    o.next(data);
                });
        });
    }

    findPlacedOrderShippingById(orderId: string) {

        return new Observable<IOrderShippingPlacedNotification>((o) => {
            //this.http.post(this.setting.apiUrl('OrderShipping/FindPlacedOrderShippingById'),
            this.apiController.post(this.setting.apiUrl('OrderShipping/FindPlacedOrderShippingById'),
                {
                    orderId: orderId
                })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: IOrderShippingPlacedNotification) => {
                    o.next(data);
                });
        });
    }

    findOrderDriverById(orderId: string) {
        
        return new Observable<IOrderDriver>((o) => {
            //this.http.post(this.setting.apiUrl('Order/FindOrderDriverById'),
            this.apiController.post(this.setting.apiUrl('Order/FindOrderDriverById'),
                {
                    orderId: orderId
                })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data:IOrderDriver) => {
                    o.next(data);
                });
        });
    }
    getTrackingUrl(orderId: string){
        return new Observable<any>((o) => {
            //this.http.post(this.setting.apiUrl('Order/FindOrderMapById'),
            this.apiController.post(this.setting.apiUrl('Order/FindOrderMapById'),
                {
                    orderId: orderId
                })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data) => {
                    o.next(data);
                });
        });
    }

    //update order to do 
   
    getUberDirectTrackingUrl(orderId: string){
        return new Observable<any>((o) => {
            //this.http.post(this.setting.apiUrl('Order/FindUberDirectOrderMapById'),
            this.apiController.post(this.setting.apiUrl('Order/FindUberDirectOrderMapById'),
                {
                    orderId: orderId
                })
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data) => {
                    o.next(data);
                });
        });
    }

    cloverCreate3DSCharge(order: IPlaceOrder, browserInfo: any, ip_address: string): Observable<ICloverCreateChargeResponseModel> {     
        let params: ICloverCreate3DSChargeRequestModel = {
            order: order,
            threeds: {
                source: "CLOVER",
                browser_info : {
                    browser_ip: ip_address,
                    ...browserInfo
                }
            }
        };

       /* params.threeds.source = "CLOVER";       
        params.threeds.browser_info = browserInfo;
        params.threeds.browser_info.browser_ip = ip_address;
*/
        return Observable.create(o => {
            this.http.post(this.setting.apiUrl('Order/CloverCreateCharge'), params)
                .pipe(finalize(() => {
                    o.complete();
                }))
                .subscribe((data: ICloverCreateChargeResponseModel) => {
                    o.next(data);

                    console.log(data);                   

                }, async error => {
                  
                    let message = this.translationService.translate("Checkout.InvalidOrder")
                    if(error)
                   {
                       //rajouter if includes doordash
                    //    if(error.errorMessage.includes('DoorDashDelivery') || error.errorMessage.includes('DoorDashDrive')){
                        
                    //         message = this.translateService.instant("Checkout.DoorDashDriveNotAvailable");
                    //    }
                        // if(error.error.includes('One of the item is not Available'))
                        // {
                        //     message=this.translateService.instant("Checkout.NotAvailable");
                        // }
                        // if(error.error.includes('Out of stock'))
                        // {
                        //     message=this.translateService.instant("Checkout.OutOfStock");
                        // }
                        // if(error.error.includes('Transaction above Limit'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLimit")} $${this.setting.configuration.maxDeliveryOrderAmount.toFixed(2)}`
                        // }
                        // if(error.error.includes('Amount is too low'))
                        // {
                        //     message=`${this.translateService.instant("Checkout.TransactionLow")} $${this.setting.configuration.minDeliveryOrderAmount.toFixed(2)}`
                        // }
                    }
                 
                    const toast = await this.toastCtrl.create({
                        message: message,
                        position: 'bottom',
                        color: 'danger',
                        cssClass: 'order-toast',
                        buttons: [
                          {
                            side: 'start',
                            icon: 'alert-circle-outline',
                            //cssClass: 'order-error-icon',
                            text: '',
                            handler: () => {
              
                            }
                          }, {
                            text: this.translationService.translate("General.Close"),
                            role: 'cancel',
                            handler: () => {
              
                            }
                          }
                        ]
                      });
                      await toast.present();                   
                });
        });
    }
    
}
